import React from "react";

const InputField = ({
  className,
  disabled,
  SecondIcon,
  position,
  Secondposition,
  name,
  placeholder,
  value,
  onChange,
  label,
  type,
  icon,
  height,
  width,
  isRequiredClass,
  labelClass,
  isRequired,
  min = "0",
  ...props
}) => {
  return (
    <div className={`${width}`}>
      {label && (
        <label className={labelClass}>
          {label} {isRequired && <span className={isRequiredClass}>*</span>}
        </label>
      )}
      <div className={`relative flex items-center ${width}`}>
        <div className={`absolute ${Secondposition}`}>{SecondIcon}</div>
        <input
          min={min}
          type={type}
          disabled={disabled}
          className={`border focus:border-2  py-2 px-3 pr-10 focus:outline-none focus:ring-2 focus:ring-[#2D9F75] w-full ${className} ${height}`}
          placeholder={placeholder}
          value={value}
          name={name}
          onChange={onChange}
          {...props}
        />
        <div className={`absolute ${position}`}>{icon}</div>
      </div>
    </div>
  );
};

export default InputField;
